const PERMISSIONS_VOUCHER_PIN_PAGE = {
  VIEW: 'voucherpin::get',
  REVEAL: 'voucherpin::reveal',
} as const;

export const REQUIRED_PERMISSIONS = [PERMISSIONS_VOUCHER_PIN_PAGE.VIEW] as const;

export type VoucherPinPagePermissionKey = (typeof REQUIRED_PERMISSIONS)[number];

export default PERMISSIONS_VOUCHER_PIN_PAGE;
